import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface RoleTranslation {
  languageId: number;
  name: string;
  description: string;
}

export interface Role {
  code: string;
  translations: RoleTranslation[];
}

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  // GET roles
  getRoles(langCode: string = ''): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}Role`);
    }

    return this.http.get(`${this.apiUrl}Role?langCode=${langCode}`);
  }

  getRoleById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}RoleById/${id}`);
  }

  create(request: any): Observable<any> {
    return this.http.post(`${this.apiUrl}Role`, request);
  }

  update(request: any, id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}Role/${id}`, request);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}Role/${id}`);
  }
}
